import { Component,OnInit,Inject } from '@angular/core';
import { MatDialogRef ,MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-loading-dialog',
  templateUrl: './loading-dialog.component.html',
  styleUrls: ['./loading-dialog.component.css']
})
export class LoadingDialogComponent implements OnInit {
  showFileFailedMessage: boolean = false;

  dailogContent:string = 'Creating OTA JOB...';
 constructor(private dialogRef: MatDialogRef<LoadingDialogComponent>,
  @Inject(MAT_DIALOG_DATA) public data: { failed: boolean }
  ){}

 ngOnInit(): void {
  //  setTimeout(() => this.dialogRef.close(),30000); // close after 30 seconds
 }

}
